var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board_wrap"},[_vm._m(0),_c('router-view',{attrs:{"name":"listVue"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board_title"},[_c('h1',[_vm._v("공지사항")])])
}]

export { render, staticRenderFns }